import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LocationDetailConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Styles.SectionContainer>
        <Skeleton variant="text" width={50} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width={80} height={24} />
        <Styles.AddressContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.AddressContainer>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width="100%" height={1} />
        <Skeleton variant="text" width={90} height={24} />
        <Skeleton variant="text" width="60%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>

      <Styles.SectionContainer>
        <Skeleton variant="text" width="100%" height={1} />
        <Skeleton variant="text" width={140} height={24} />
        <Skeleton variant="text" width="60%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.SectionContainer>
    </Styles.MainContainer>
  )
}

export default LocationDetailConfigurationSkeleton
